import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MonthView from './components/MonthView/MonthView';
import WeekView from './components/WeekView/WeekView';

const Dashboard = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Paper square>
        <Tabs
          indicatorColor="primary"
          onChange={handleChange}
          textColor="primary"
          value={value}>
          <Tab label="Weekly View" />
          <Tab label="Monthly View" />
        </Tabs>
      </Paper>
      <div style={{ display: value === 0 ? 'block' : 'none' }}>
        <WeekView />
      </div>
      <div style={{ display: value === 1 ? 'block' : 'none' }}>
        <Grid container justifyContent="center">
          <MonthView />
        </Grid>
      </div>
    </>
  );
};

export default Dashboard;
